export default __webpack_public_path__ + "static/media/3722f3306c0ffbba.8aea919e2393db01fc71a152584ea6e1.svg";